// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__7qX6y","mobileHeader":"styles_mobileHeader__AhQy9","logo":"styles_logo__Wjwb-"};